import { JsonApiModel } from 'pf-frontend-common/src/module/json-api/model';

export class PropertyReportEligibilityModel extends JsonApiModel {
  /**
   * @inheritDoc
   */
  public static readonly JSONAPI_TYPE: string = 'cmt_eligible_check';

  /**
   * @inheritDoc
   */
  public jsonApiType: string = PropertyReportEligibilityModel.JSONAPI_TYPE;

  /**
   * @inheritDoc
   */
  public jsonApiAttributes: Array<keyof PropertyReportEligibilityModel> = ['agent_email', 'property_id'];

  /**
   * @inheritDoc
   */
  public jsonApiRelationships: Array<keyof PropertyReportEligibilityModel> = [];

  /**
   * Agent Email
   */
  public agent_email: string = '';
  /**
   * Property id
   */
  public property_id: number = null;
}
